<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Détail du mouvement de stock</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">

                        <div v-if="messagesucces !== ''" class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-check-circle-line"></i><span>{{ messagesucces }}</span>
                        </div>
                        <div v-if="messageerror !== ''" class="cf-note cf-note--danger" style="margin-bottom:0.75rem;">
                            <i class="ri-error-warning-line"></i><span>{{ messageerror }}</span>
                        </div>

                        <div class="cf-note cf-note--info">
                            <i class="ri-information-line"></i>
                            <span>Date : <strong>{{ Items.datedoc }}</strong> &nbsp;·&nbsp; Saisie par : <strong>{{ Items.saisiepar }}</strong></span>
                        </div>

                        <div class="mt-4">
                            <div v-if="typedoc !== 'mvt_transfert'" class="space-y-2">
                                <label class="cf-field-label">Magasin / Dépôt / Entrepôt</label>
                                <input type="text" class="cf-inp" disabled :value="Items.mag.name">
                            </div>

                            <div v-if="typedoc === 'mvt_transfert'" class="grid lg:grid-cols-2 gap-4">
                                <div class="space-y-2">
                                    <label class="cf-field-label">Magasin / Dépôt / Entrepôt</label>
                                    <input type="text" class="cf-inp" disabled :value="Items.mag.name">
                                </div>
                                <div class="space-y-2">
                                    <label class="cf-field-label">Vers magasin / dépôt / entrepôt</label>
                                    <input type="text" class="cf-inp" disabled :value="Items.jsonotherdonne.magvers.name">
                                </div>
                            </div>

                            <div class="space-y-2 mt-3">
                                <label class="cf-field-label">Motif / Raison</label>
                                <textarea :value="Items.docobservation" disabled class="cf-inp cf-textarea" cols="5" rows="2"></textarea>
                            </div>

                            <div v-if="Items.params.param1 !== null" class="space-y-2 mt-3">
                                <label class="cf-field-label">Paramètre d'indication</label>
                                <input type="text" class="cf-inp" disabled :value="Items.params.param1.name">
                            </div>
                        </div>

                        <!-- Lignes -->
                        <div class="table-scroll-wrap art-scroll mt-4">
                            <table class="art-table">
                                <thead class="table-head">
                                <tr>
                                    <th class="th th--center" style="width:60px;">N°</th>
                                    <th class="th" colspan="2">Désignation</th>
                                    <th class="th th--right">Quantité</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="listedatatable.length">
                                    <tr v-for="(datavalue, index) in listedatatable" :key="index" class="table-row">
                                        <td class="td td--center"><span class="row-number">{{ index + 1 }}</span></td>
                                        <td class="td" colspan="2"><span style="font-weight:500;color:var(--cf-ink-strong);">{{ datavalue.article.libelle }}</span></td>
                                        <td class="td td--right">{{ datavalue.qtite }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="20">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                <p class="empty-state__title">Aucun enregistrement</p>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="btnimpression" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-printer-line align-middle"></i> Imprimer
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <modalimpressiondoc ref="modalimpressiondoc"></modalimpressiondoc>
</template>

<script>
   /* import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";*/
   // import allfunction from "@/allfunction";
   import { randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
   import modalimpressiondoc from "@/components/views/pages/stock/mvtstock/modal_etatdocstock";
   //import modallistedesarticles from "@/components/views/pages/stock/mvtstock/modal_listedesarticles";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{

            listeversmagasins(){
                let mvalue=[];
                this.Items.jsonotherdonne.magvers=null;
                if (this.Items.mag!==null){

                    mvalue = this.alldata.magasin.filter(m => m.pid !== this.Items.mag.pid)

                }

                return mvalue;
            },

            disableddoc(){

                return !!this.Items.docnum;
            },
            stock: function (){

                if (this.ItemsArticle.article!==null){
                    return parseFloat(this.ItemsArticle.article.rstck);
                    //  return "";
                }else{
                    return 0;
                    // return "disabled";
                }

            },





        },
        components: {
           /* templatesite,
            appheader,
            appsidebar,
            appmenu,

            modallistedesarticles*/

            modalimpressiondoc

        },

        data() {
            return {
                isdisplayviewarticle:false,
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typeaction:"add",
                Items: {},
                alldata: [],

                listedatatable:[],
                listedatatableproduit:[],
                mydocmag:'',

            };
        },
        methods: {

            btnimpression(){

                this.$refs.modalimpressiondoc.show(this.Items);

            },



            close(){

                this.listedatatableproduit=[];
                this.listedatatable=[];
                this.ItemsArticle={
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    etatline:0,
                    pid:''
                }
                this.isdisplayviewarticle=false;
                this.isdisplay=false;

                this.$emit('closed');

            },


          async  showupdate(titlemodal,typeaction,typedoc,Items,alldata){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.typedoc=typedoc
                this.Items=Items
                this.alldata=alldata
                this.messagesucces="";
                this.messageerror="";

              this.ItemsArticle={
                  docnum:Items.numdoc,
                  article:null,
                  qtite:0,
                  diqte:0,
                  pu:0,
                  pa:0,
                  mtnt:0,
                  mtntclt:0,
                  remise:0,
                  doc:'',
                  docpid:Items.pid,
                  docnumother:'',
                  docmag:'',
                  doctp:'',
                  linekey:'',
                  etatline:0,
                  pid:''
              }

                if (this.Items.pid!==""){this.isdisplayviewarticle=true}

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/'+this.Items.numdoc+'/'+this.Items.pid+'/open/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.listedatatableproduit=[];
                            t.listedatatableproduit=res.data.m;

                             t.Items.jsonotherdonne=Items.jsonotherdonne;
                            t.Items.mag=Items.mag;
                            t.Items.pid=Items.pid;
                            t.ItemsArticle.docpid=Items.pid;
                            t.Items.params=Items.params;
                            t.Items.mtnt=Items.mtnt;
                            t.Items.docnum=Items.numdoc;


                            t.Items.docnumother=Items.docnumother;
                            t.Items.docpid=Items.pid;
                            t.Items.pid=Items.pid;
                            t.Items.infodoc=Items.infodoc;
                            t.Items.datedoc=Items.datedoc;
                            t.Items.doctyp=Items.doctyp;
                            t.Items.docobservation=Items.observations;


                            //t.listearticles=response.data.allprod;

                            t.listedatatable=res.data.alllignedoc;
                           t.mydocmag=Items.mag.pid;
                            t.ItemsArticle.docmag=Items.mag.pid;
                            //t.itemArticle.docnum=value.numdoc;
                            t.ItemsArticle.docnum=Items.pid;
                            t.ItemsArticle.doctp=Items.doctyp;
                            t.ItemsArticle.docnumother=Items.docotherref;


                            t.isdisplayviewarticle=true;
                            t.isdisplay=true;

                        }
                        else{
                            t.listedatatableproduit=[];
                           // t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })

            },

            newArticle(){
                this. ItemsArticle.docmag=this.mydocmag;
                this. ItemsArticle.article=null;
                this. ItemsArticle.qtite=0;
                this. ItemsArticle.pu=0;
                this. ItemsArticle.remise=0;
                this. ItemsArticle.mtnt=0;
                this. ItemsArticle.pid='';
                this. ItemsArticle.linekey='';
                this. ItemsArticle.etatline=0;
                this.ItemsArticle.spid='';
                this.disabled=false;
            },


            changeItem(value){

                let pid=this.ItemsArticle.pid;
               // let value=event;
                if (pid!=='') return;
                let dataSearch=[];

                if(value!==null){

                    if(this.listedatatable.length !==0){


                        dataSearch = this.listedatatable.filter(function (article) {

                            return  article.article.pid ===value.pid
                            //return article.pidar.includes(value.pid);
                        });


                        if(dataSearch.length !==0){
                            toastr['error']( value.libelle+' existe déjà dans la liste.',"<b></b>");
                            this.ItemsArticle.article=null;
                            this.ItemsArticle.qtite=0;
                            this.ItemsArticle.pu= 0
                        }else{
                            // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                            //this.itemArticle.pu= this.itemArticle.article.pu

                            this.gestionPu();


                        }


                    }else{
                        // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                        // this.itemArticle.pu=this.itemArticle.article.pu
                        //this.itemArticle.pu= this.itemArticle.article.pu
                        this.gestionPu();
                    }


                }


            },

            gestionPu(){

                //***************************** le bon ok ******************************//


                if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                    if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                        if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                            let cal=   parseInt(this.ItemsArticle.article.pa)/1.18
                            this.ItemsArticle.pa=Math.round(cal)
                            this.ItemsArticle.pu=this.ItemsArticle.article.pu

                        }
                        else{

                            let cal=   parseInt(this.ItemsArticle.article.pa)*0.18
                            this.ItemsArticle.pa=this.ItemsArticle.article.pa
                            this.ItemsArticle.pu=Math.round(cal)

                        }



                    }
                    else{

                        this.ItemsArticle.pa=this.ItemsArticle.article.pa
                        this.ItemsArticle.pu=this.ItemsArticle.article.pu

                    }






                }
                else{

                    this.itemArticle.pa=this.itemArticle.article.pa
                    this.itemArticle.pu=this.itemArticle.article.pu

                }



            },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:960px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-inp:disabled { background:var(--cf-surface); color:var(--cf-muted); cursor:not-allowed; }
.cf-textarea { height:auto; min-height:56px; padding:8px 12px; resize:vertical; }

.table-scroll-wrap { overflow:auto; }
.art-scroll { max-height:34vh; }
.art-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:420px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.td--right { text-align:right; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }

.empty-state { padding:2rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:36px; color:var(--cf-faint); margin-bottom:10px; }
.empty-state__title { font-size:0.9rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.art-scroll::-webkit-scrollbar { width:6px; height:6px; }
.art-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>
